import { ReactNode } from 'react';

interface InfoRowProps {
    label: string;
    value: ReactNode;
}

export default function InfoRow({ label, value }: InfoRowProps) {
    return (
        <>
            <dt className="pb-2 text-[15px] border-b-[0.5px] border-line text-fg/68">{label}</dt>
            <dd className="pb-2 text-[15px] border-b-[0.5px] border-line text-fg min-w-0 break-words">
                {value || '—'}
            </dd>
        </>
    );
}
